import { React, useState } from "react";
import logo from "../assets/Logo.svg";
import "../App.css";

const Footer = () => {

    


    return (
      <><footer className="footer">
        <div className="logo-container">
          <img src={logo} alt="Company Logo" className="logo" />
        </div>
        <div className="license-container">
          <p className="license-text">License Numbers: <span className="license-placeholder">XXXX-XXXX-XXXX</span></p>
        </div>
      </footer></>
    );
  };
  
  export default Footer;
  